// extracted by mini-css-extract-plugin
module.exports = {"empty-table-alert":"configure-translations_empty-table-alert_2e_B-"};